export const FieldActivityStatus = {
  DONE: 'done',
  TODO: 'todo',
  EXPIRED: 'expired',
};
